import React from 'react';

import {
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  Legend,
  ResponsiveContainer,
  Tooltip
} from 'recharts';

import { answerColorDict } from '../../../resources/thematic-topics';



class CheckboxView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderTooltip = this.renderTooltip.bind(this);
  }

  splitQuestionString(data) {
    return data.map(item => {
      item.questionId = item.question.split(' ', 1)[0];
      return item;
    })
  }

  renderTooltip(props) {
    const { active } = props;

    if (active) {
      const { payload, label } = props;
      const data = this.splitQuestionString(this.props.data);
      const currentItem = data.find(item => item.questionId === label);

      return (
        <div
          className="recharts-default-tooltip"
          style={{
            margin: '0px',
            padding: '10px',
            backgroundColor: 'rgb(255, 255, 255)',
            border: '1px solid rgb(204, 204, 204)',
            whiteSpace: 'wrap'
          }}
        >
          <p className="recharts-tooltip-label">{ currentItem.question }</p>
          <ul
            className="recharts-tooltip-item-list"
            style={{ padding: '0px', margin: '0px' }}
          >
            <li
              className="recharts-tooltip-item"
              style={{
                display: 'block',
                paddingTop: '4px',
                paddingBottom: '4px',
                color: answerColorDict.Yes
              }}
            >
              <span className="recharts-tooltip-item-name">Yes</span>
              <span className="recharts-tooltip-item-separator"> : </span>
              <span className="recharts-tooltip-item-value">{ currentItem.Yes }</span>
              <span className="recharts-tooltip-item-unit"> countries</span>
            </li>
            <li
              className="recharts-tooltip-item"
              style={{
                display: 'block',
                paddingTop: '4px',
                paddingBottom: '4px',
                color: answerColorDict.No
              }}
            >
              <span className="recharts-tooltip-item-name">No</span>
              <span className="recharts-tooltip-item-separator"> : </span>
              <span className="recharts-tooltip-item-value">{ currentItem.No }</span>
              <span className="recharts-tooltip-item-unit"> countries</span>
            </li>
          </ul>
        </div>
      );
    }

    return null;
  }

  render() {
    const { data, numberStates } = this.props;

    return (
      <ResponsiveContainer width="100%" height={210}>
        <BarChart
          margin={{ top: 20 }}
          data={ this.splitQuestionString(data) }
          layout="vertical"
        >
          <XAxis
            hide
            type="number"
            domain={[0, numberStates]}
          />
          <YAxis
            dataKey="questionId"
            type="category"
            axisLine={false}
            tickLine={false}
            width={ 20 }
            interval={0}
            fontWeight="bold"
            tick={{ fill: '#333', fontSize: '10px' }}
          />
          <Tooltip content={ this.renderTooltip }/>
          <CartesianGrid
            strokeDasharray="8 3"
            verticalPoints={[20, 20, 40]}
          />
          <Legend layout="horizontal" align="center" iconSize={10} />
          <Bar
            unit=" countries"
            label
            dataKey="Yes"
            fill={ answerColorDict.Yes }
          />
          <Bar
            unit=" countries"
            label
            dataKey="No"
            fill={ answerColorDict.No }
          />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default CheckboxView;



// WEBPACK FOOTER //
// ./src/components/Statistics/Views/CheckboxView.js